// Wraps occurrences of `query` (case-insensitive) in <mark>. Renders as
// text — input is never interpreted as HTML.

interface Props {
  text: string;
  query: string;
}

function escapeRegExp(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function Highlight({ text, query }: Props): JSX.Element {
  if (!query) return <>{text}</>;
  // Capture group → split returns alternating non-matches and matches:
  // ["before", "match", "between", "match", "after"]. Odd indices are matches.
  const re = new RegExp(`(${escapeRegExp(query)})`, "ig");
  const parts = text.split(re);
  return (
    <>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <mark key={i} className="bg-amber-300/30 text-ink-100 rounded px-0.5">
            {part}
          </mark>
        ) : (
          <span key={i}>{part}</span>
        ),
      )}
    </>
  );
}
